import * as React from "react"
import { Label } from "@/components/ui/label"
import { Input as ShadcnInput } from "@/components/ui/Input"
import { FormMessage } from "@/components/ui/form"
import { cn } from "@/lib/utils"

export interface ShadcnFormFieldProps extends React.ComponentProps<"input"> {
 label?: string
 error?: string
 leftIcon?: React.ReactNode
 rightIcon?: React.ReactNode
 hint?: string
 required?: boolean
 containerClassName?: string
}

const ShadcnFormField = React.forwardRef<HTMLInputElement, ShadcnFormFieldProps>(
 (
 {
 label,
 error,
 leftIcon,
 rightIcon,
 hint,
 required,
 containerClassName,
 className,
 id,
 ...props
 },
 ref
 ) => {
 const fieldId = id || React.useId()

 return (
 <div className={cn("space-y-2", containerClassName)}>
 {label && (
 <Label htmlFor={fieldId} className={required ? "after:content-['*'] after:ml-0.5 after:text-destructive" : ""}>
 {label}
 </Label>
 )}
 <div className="relative">
 {leftIcon && (
 <div className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground">
 {leftIcon}
 </div>
 )}
 <ShadcnInput
 ref={ref}
 id={fieldId}
 className={cn(
 leftIcon && "pl-10",
 rightIcon && "pr-10",
 error && "border-destructive focus-visible:ring-destructive",
 className
 )}
 aria-invalid={!!error}
 aria-describedby={error ? `${fieldId}-error` : hint ? `${fieldId}-hint` : undefined}
 {...props}
 />
 {rightIcon && (
 <div className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground">
 {rightIcon}
 </div>
 )}
 </div>
 {hint && !error && (
 <p id={`${fieldId}-hint`} className="text-[0.8rem] text-muted-foreground">
 {hint}
 </p>
 )}
 {error && (
 <FormMessage id={`${fieldId}-error`} className="text-[0.8rem] font-medium text-destructive">
 {error}
 </FormMessage>
 )}
 </div>
 )
 }
)
ShadcnFormField.displayName = "ShadcnFormField"

export { ShadcnFormField }

